import Stator from '../assets/img/stator.png';
import Ackno from '../assets/img/ackno.png';
import Enjin from '../assets/img/enjin.png';
import HarmonyLauncher from '../assets/img/harmony-launcher.png';
import WorldCyptoids from '../assets/img/world-cryptoids.png';
import King from '../assets/img/king.png';




export const performance = [
    {
    img: Stator,
    boost: 73,
    amount: 75000
    },
    {
    img: Ackno,
    boost: 48,
    amount: 75000
    },
    {
    img: Enjin,
    boost: 29,
    amount: 75000
    },
    {
    img: HarmonyLauncher,
    boost: 21,
    amount: 75000
    },
    {
    img: WorldCyptoids,
    boost: 17,
    amount: 75000
    },
    {
    img: King,
    boost: 73,
    amount: 75000
    },
    


]

export const partner = [
    {
        text: 'Delivery Partner',
        img: WorldCyptoids
    },
    {
        text: 'Finance Partner',
        img: WorldCyptoids
    },
    {
        text: 'Partner Partner',
        img: WorldCyptoids
    },
    {
        text: 'Privacy Partner',
        img: WorldCyptoids
    },
    {
        text: 'Hospitality Partner',
        img: WorldCyptoids
    },
    
]